<template>
  <div
    class="ns-currency"
    :class="{
      'ns-currency__loading': loading,
      'ns-currency__strike-through': strikeThrough
    }"
    :data-qa-price="amount"
  >
    {{ formattedCurrency }}
  </div>
</template>

<script>
import { CurrencyService } from "@nuskin/ns-shop";
import { RunConfigService } from "@nuskin/ns-util";

export default {
  name: "NsCurrency",
  props: {
    /**
     * The currency amount to display
     */
    amount: {
      type: Number,
      required: true
    },
    /**
     * Set to block display of currency until ready
     */
    loading: Boolean,
    /**
     * Strike out the currency amount
     */
    strikeThrough: Boolean
  },
  computed: {
    formattedCurrency() {
      let runConfig = RunConfigService.getRunConfig();
      return CurrencyService.format(
        this.amount,
        runConfig.country,
        runConfig.language
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/other";

::-moz-selection {
  background: map.get(colors.$themeColors, color-interactive-5);
}
::selection {
  background: map.get(colors.$themeColors, color-interactive-5);
}

.ns-currency__loading {
  position: relative;
  display: inline-block;
  margin: 0;
  width: 60px;
  height: 20px;
  background-image: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.25) 50%,
      rgba(255, 255, 255, 0) 100%
    ),
    linear-gradient(
      map.get(colors.$themeColors, color-gray-4) 100%,
      transparent 0
    );
  background-repeat: no-repeat;
  background-size: 20px 100%, 100% 100%;
  background-position: -25% 0, 0 0;
  animation: blockFrame 0.5s ease-in-out infinite;
  color: transparent;
  z-index: map.get(other.$otherUtils, z--primary);
}

.ns-currency__strike-through {
  text-decoration: line-through;
}

@keyframes blockFrame {
  to {
    background-position: 120% 0, 0 0;
  }
}
</style>
